import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  rootActions: { justifyContent: "space-between !important" },
  rootHeader: { display: "flex", justifyContent: "space-between" },
}));
